import { Injectable } from "@angular/core";
import {
    MC_EVENT_TYPE,
    MCFieldConfigurationService,
    MCFieldTypesService,
    MCUtils
} from "@maslul/common-services";
import { MICustomFunctionsParams } from "../../models/fields/custom-function-params";

@Injectable({
    providedIn: 'root'


})
export class FieldsEventsService {

    constructor(private fieldConfigurationService: MCFieldConfigurationService,
        private fieldTypesService: MCFieldTypesService) {

    }

    change(customFunctionsObj: MICustomFunctionsParams) {
        const fieldSchema = customFunctionsObj.fieldSchema;
        const eventsCallBackService = customFunctionsObj.injector.get(customFunctionsObj.eventsCallBackService);

        if (this.fieldConfigurationService.isHaveEvents(fieldSchema)) {
            return (item: any, event: any) => {

                customFunctionsObj.item = item;
                customFunctionsObj.isOnSelect = true;
                customFunctionsObj.value = event.target ? event.target.value : event;
                customFunctionsObj.params = event.params;
                customFunctionsObj.index = MCUtils.tryParseInt(item?.parent?.key) || 0;
                const changeEvents = fieldSchema.events.filter(e => e.event == MC_EVENT_TYPE.OnChange);
                changeEvents.forEach(e => {
                    if (eventsCallBackService.eventsCallBack[e.functionName]) {
                        eventsCallBackService.eventsCallBack[e.functionName](customFunctionsObj)
                    }
                    else {
                        console.error(`change event fail field: ${fieldSchema.name}, function ${e.functionName}`)
                    }
                });
            }
        }
        else {
            return undefined;
        }

    }

    keyUp(customFunctionsObj: MICustomFunctionsParams) {
        const fieldSchema = customFunctionsObj.fieldSchema;
        const eventsCallBackService = customFunctionsObj.injector.get(customFunctionsObj.eventsCallBackService);


        if (this.fieldConfigurationService.isHaveEvents(fieldSchema)) {
            return (item: any, event: any) => {
                customFunctionsObj.item = item;
                customFunctionsObj.value = event.target ? event.target.value : event;
                customFunctionsObj.params = event.params;
                customFunctionsObj.index = MCUtils.tryParseInt(item?.parent?.key) || 0;
                const keyUpEvents = fieldSchema.events.filter(e => e.event == MC_EVENT_TYPE.OnKeyUp);
                keyUpEvents.forEach(e => {
                    if (eventsCallBackService.eventsCallBack[e.functionName]) {
                        eventsCallBackService.eventsCallBack[e.functionName](customFunctionsObj)
                    }
                    else {
                        console.error(`keyUp event fail field: ${fieldSchema.name}, function ${e.functionName}`)
                    }
                });
            }
        }
        else {
            return undefined;
        }

    }


    focus(customFunctionsObj: MICustomFunctionsParams) {
        const fieldSchema = customFunctionsObj.fieldSchema;
        const eventsCallBackService = customFunctionsObj.injector.get(customFunctionsObj.eventsCallBackService);

        if (this.fieldConfigurationService.isHaveEvents(fieldSchema)) {
            return (item: any, event: any) => {
                customFunctionsObj.item = item;
                customFunctionsObj.isOnSelect = true;
                customFunctionsObj.value = event.target ? event.target.value : event;
                customFunctionsObj.params = event.params;
                customFunctionsObj.index = MCUtils.tryParseInt(item?.parent?.key) || 0;
                const focusEvents = fieldSchema.events.filter(e => e.event == MC_EVENT_TYPE.OnFocus);
                focusEvents.forEach(e => {
                    if (eventsCallBackService.eventsCallBack[e.functionName]) {
                        eventsCallBackService.eventsCallBack[e.functionName](customFunctionsObj);
                    }
                    else {
                        console.error(`focus event fail field: ${fieldSchema.name}, function ${e.functionName}`)
                    }
                });
            }
        }

        else {
            return undefined;
        }

    }

    onValueSelect(customFunctionsObj: MICustomFunctionsParams) {
        const fieldSchema = customFunctionsObj.fieldSchema;
        const eventsCallBackService = customFunctionsObj.injector.get(customFunctionsObj.eventsCallBackService);

        if (this.fieldConfigurationService.isHaveEvents(fieldSchema) && this.fieldTypesService.isAutoComlete(fieldSchema.type)) {
            return (item: any, event: any) => {

                customFunctionsObj.item = item;
                customFunctionsObj.isOnSelect = true;
                customFunctionsObj.value = event.target ? event.target.value : event;
                customFunctionsObj.params = event.params;
                customFunctionsObj.index = MCUtils.tryParseInt(item?.parent?.key) || 0;
                const valueSelectEvents = fieldSchema.events.filter(e => e.event == MC_EVENT_TYPE.OnChange);
                valueSelectEvents.forEach(e => {
                    if (eventsCallBackService.eventsCallBack[e.functionName]) {
                        eventsCallBackService.eventsCallBack[e.functionName](customFunctionsObj);
                    }
                    else {
                        console.error(`onValueSelect event fail field: ${fieldSchema.name}, function ${e.functionName}`)
                    }
                });
            }
        }

        else {
            return undefined;
        }

    }

    onNewValueAdded(customFunctionsObj: MICustomFunctionsParams) {
        const fieldSchema = customFunctionsObj.fieldSchema;
        const eventsCallBackService = customFunctionsObj.injector.get(customFunctionsObj.eventsCallBackService);

        if (this.fieldConfigurationService.isHaveEvents(fieldSchema)) {
            return (item: any, event: any) => {

                customFunctionsObj.item = item;
                customFunctionsObj.isOnSelect = true;
                customFunctionsObj.value = event.target ? event.target.value : event;
                customFunctionsObj.params = event.params;
                customFunctionsObj.index = MCUtils.tryParseInt(item?.parent?.key) || 0;
                const newValueAddedEvents = fieldSchema.events.filter(e => e.event == MC_EVENT_TYPE.OnNewValueAdded);
                newValueAddedEvents.forEach(e => {
                    if (eventsCallBackService.eventsCallBack[e.functionName]) {
                        eventsCallBackService.eventsCallBack[e.functionName](customFunctionsObj);
                    }
                    else {
                        console.error(`newValueAddedEvents event fail field: ${fieldSchema.name}, function ${e.functionName}`)
                    }
                });
            }
        }

        else {
            return undefined;
        }

    }


}